import { useParams } from "react-router-dom";
import { blogs } from "./BlogData";

import ReactMarkdown from "react-markdown";

const BlogDetails = () => {
  const { id } = useParams();
  const blog = blogs.find((item) => item.id === Number(id));

  if (!blog) return <div>Blog Not Found</div>;

  return (
    <section className="py-12 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <img
          src={blog.image}
          alt={blog.title}
          className="w-full  h-96 object-contain  rounded-xl  md:mb-8 mb-4"
        />

        <h1 className="md:text-3xl text-xl font-semibold mb-6 font-serif">{blog.title}</h1>

        <div className="text-gray-700 leading-relaxed whitespace-pre-line">
          <div className="prose max-w-none font-quicksand">
            <ReactMarkdown>{blog.content}</ReactMarkdown>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetails;
